import { IComponentOptions } from "angular";
import { MachineChangeComponentController } from "./controller";
import {
  SingleMachineChangeChildStateConfig,
  vsSingleServiceName as singleChangeServiceName,
} from "./singleProvider";

export const vsSingleComponentName = "machineChangesSingle";
class MachineChangeComponentControllerSingle extends MachineChangeComponentController<SingleMachineChangeChildStateConfig> {
  static $inject = [singleChangeServiceName];
}

export const MachineChangeSingleComponentOptions: IComponentOptions = {
  controller: MachineChangeComponentControllerSingle,
  controllerAs: "machineChangeController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    disabled: "<?",
    childClicked: "&",
    childDisabled: "&?",
  },
};
